var map = {
	"./Archive.zip": "ed3b",
	"./Avocado-2.jpg": "4ef9",
	"./Durian.jpg": "9cd6",
	"./Nangka-J33.jpg": "c0a3",
	"./WhatsApp Image 2021-07-08 at 11.41.43.jpeg": "0231",
	"./aktiviti-kelapa-pandan.png": "e2a5",
	"./aktiviti-kelapa-sawit.png": "f09f",
	"./aktiviti-kelapa-tacunan.png": "90e4",
	"./anak-benih-kelapa-pandan.png": "fe99",
	"./anak-benih-sawit.jpeg": "b391",
	"./anak-benih-sawit.png": "8166",
	"./benih-tacunan.jpg": "1661",
	"./header-banner.png": "b80c",
	"./icon-penganugerahan.png": "7fc1",
	"./kelapa-pandan.jpeg": "03cc",
	"./kelapa-tacunan.jpeg": "b1c1",
	"./logo-primary.png": "a1e7",
	"./logo-white.png": "06f1",
	"./musang-king.jpeg": "4f88",
	"./newThumb/Avocado-1.jpg": "8d48",
	"./newThumb/Durian-2.jpg": "4c2e",
	"./penganugerahan/Assets-Award-01.png": "06d8",
	"./penganugerahan/Assets-Award-02.png": "9133",
	"./penganugerahan/Assets-Award-03.png": "875e",
	"./penganugerahan/Assets-Award-04.png": "6d09",
	"./penganugerahan/Assets-Award-05.jpg": "45ed",
	"./penganugerahan/anugerah1.jpg": "5044",
	"./penganugerahan/anugerah2.jpg": "5ec6",
	"./penganugerahan/anugerah3.jpg": "e995",
	"./penganugerahan/kelapa-pandan.jpeg": "7b8d",
	"./penganugerahan/kelapa-tacunan.jpeg": "7065",
	"./penganugerahan/musang-king.jpeg": "efe9",
	"./penganugerahan/projek-nenas.jpeg": "9936",
	"./penganugerahan/signboard.jpg": "19b9",
	"./penganugerahan/tractor.jpeg": "a4dd",
	"./pengurusan/20211017_092217.jpg": "5df4",
	"./pengurusan/20211017_092702.jpg": "f2df",
	"./pengurusan/20211017_092821.jpg": "85f4",
	"./pengurusan/20211017_093012.jpg": "7974",
	"./pengurusan/20211017_095947.jpg": "c4a8",
	"./pengurusan/ashraf.jpg": "955d",
	"./pengurusan/dr-Rahim.jpg": "6668",
	"./pengurusan/drRahim.JPG": "b1da",
	"./pengurusan/idrus.jpg": "fb0e",
	"./pengurusan/jupri_demabela.jpg": "8417",
	"./pengurusan/lagani_sahid.jpg": "f3bb",
	"./pengurusan/mc_ismail.jpg": "a2e5",
	"./pengurusan/paken.jpg": "79c9",
	"./pengurusan/pengerusi.jpg": "e97e",
	"./pengurusan/tim_pengarah.jpg": "6f17",
	"./perumahan-ranggu-saujana.png": "de9f",
	"./projek-nenas.jpeg": "13f9",
	"./quote-banner.png": "c4e1",
	"./thumbdrive/aktiviti-lawatan.jpeg": "7994",
	"./thumbdrive/aktiviti-pembersihan.jpeg": "4bcb",
	"./thumbdrive/kolam.jpeg": "2135",
	"./thumbdrive/ladang-bt-13-1.jpeg": "1c23",
	"./thumbdrive/ladang-bt-13-2.jpeg": "37f5",
	"./thumbdrive/nenas.jpeg": "b714",
	"./thumbdrive/people.JPG": "0c46",
	"./thumbdrive/skim-pengesahan-bahan-tanaman-1.jpeg": "35fe",
	"./thumbdrive/skim-pengesahan-bahan-tanaman-2.jpeg": "0909",
	"./thumbdrive/tapak-semaian-kelapa-sawit-1.jpeg": "aa71",
	"./thumbdrive/tapak-semaian-kelapa-sawit-2.jpeg": "62a3",
	"./thumbdrive/tapak-semaian-kelapa-sawit-bt-19.jpeg": "d896",
	"./thumbdrive/tapak-semaian-kelapa-tacunan-1.jpeg": "7be0",
	"./thumbdrive/tapak-semaian-kelapa-tacunan-3.jpeg": "fdbff",
	"./thumbdrive/tapak-semaian-kelapa-tacunan-4.jpeg": "3c49",
	"./thumbdrive/tapak-semaian-kelapa-tacunan-bt-14.jpeg": "dfd3",
	"./user.png": "ba97"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";